import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Block as ZinniaBlock, Img, } from '@zapier/design-system';
import { useTracking } from '../../tracking';
import { RichText } from '../RichText';
import { Video } from '../Video';
function Media(props) {
    var _a, _b;
    if (props.imageUrl) {
        return _jsx(Img, { alt: (_a = props.imageAltText) !== null && _a !== void 0 ? _a : '', src: props.imageUrl });
    }
    if ((_b = props.video) === null || _b === void 0 ? void 0 : _b.videoUrl) {
        return _jsx(Video, Object.assign({}, props.video));
    }
    return null;
}
export function Block(props) {
    var _a, _b;
    const { emitUserInteractionEvent } = useTracking();
    const emitCTAClickEvent = () => {
        emitUserInteractionEvent({
            event_action: 'click',
            interaction_name: 'call_to_action',
            interaction_raw_text: props.ctaText,
            destination_href: props.ctaHref,
            option_selected: 'cta_button',
        });
    };
    const emitSecondaryCTAClickEvent = () => {
        emitUserInteractionEvent({
            event_action: 'click',
            interaction_name: 'call_to_action',
            interaction_raw_text: props.secondaryCtaText,
            destination_href: props.secondaryCtaHref,
            option_selected: 'cta_link',
        });
    };
    return (_jsx(ZinniaBlock, { heading: props.heading, description: props.description && _jsx(RichText, { html: props.description }), ctaText: props.ctaText, ctaHref: props.ctaHref, secondaryCtaText: props.secondaryCtaText, secondaryCtaHref: props.secondaryCtaHref, isCentered: props.isCentered, isLink: props.isLink, smallText: props.smallText, iconName: props.iconName, iconColor: props.iconColor, media: (_a = props.children) !== null && _a !== void 0 ? _a : ((props.imageUrl || ((_b = props.video) === null || _b === void 0 ? void 0 : _b.videoUrl)) && (_jsx(Media, { imageUrl: props.imageUrl, imageAltText: props.imageAltText, video: props.video }))), onCtaClick: emitCTAClickEvent, onCtaKeyDown: (event) => {
            event.key === 'Enter' && emitCTAClickEvent();
        }, onSecondaryCtaClick: emitSecondaryCTAClickEvent, onSecondaryCtaKeyDown: (event) => {
            event.key === 'Enter' && emitSecondaryCTAClickEvent();
        } }));
}
//# sourceMappingURL=Block.js.map